import { render } from "./MultipleEconomyFileUpload.vue?vue&type=template&id=bd00d476"
import script from "./MultipleEconomyFileUpload.vue?vue&type=script&lang=js"
export * from "./MultipleEconomyFileUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__